var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('img', {
    staticClass: "logo md-hidden",
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/media_logo_pc.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo  lg-hidden md-visible",
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/media_logo_mb.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mt-190 qrcode",
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/page_media.jpeg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-fff fs-20 mt-20"
  }, [_vm._v("\n      按要求完成相关信息填写，申请记者证\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "passport_other",
    on: {
      "click": _vm.tomedia
    }
  }, [_c('span', [_vm._v("持护照及其他证件的媒体请点击")]), _vm._v(" "), _c('span', [_vm._v("Reporters from other countries and areas please click here")])]), _vm._v(" "), _vm._m(0)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "fs-20 color-fff"
  }, [_vm._v("\n      广州数字展会网络技术有限公司版权所有\n      "), _c('a', {
    staticClass: "color-fff",
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn/"
    }
  }, [_vm._v("粤ICP备13061573号-5")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541da1c5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/mediaApply.vue
// module id = null
// module chunks = 